import React from 'react'
import axios from 'axios'
import api from '../../../utils/API';
import { FormattedMessage } from 'react-intl';

class SSOSignIn extends React.Component {
  state = {
    email: '',
    password: '',
    rememberMe: false,
    error: '',
    name: '',
    isLogin: false,
  }

  handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    this.setState({ [event.target.name]: value })
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.handleLogIn(event)
    }
  }

  errorMessage = (err) => {
    switch(err.response.status) {
      case 400:
        this.setState({ error: <FormattedMessage id="INVALID_PARAMETERS" /> })
        break;
      case 401:
      case 500:
        this.setState({ error: <FormattedMessage id={err.response.data.toUpperCase()} /> })
        break;
      default:
        this.setState({ error: err.message })
    }
  }

  handleLogIn = (event) => {
    event.preventDefault()
    const search = new URLSearchParams(window.location.search)

    if(this.state.isLogin) {
      if(this.props.product === 'CMS') {
        api.loginCms(this.state.email, this.state.password, 
          search.get('cms-id'), search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err);
        })
      }
      else if (this.props.product === 'CC-Server') {
        api.loginCCServer(this.state.email, this.state.password, 
          search.get('cc-server-id'), search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err)
        }) 
      }
    } else {
      if(this.props.product === 'CMS') {
        api.registerCms(this.state.email, this.state.password, 
          this.state.name, search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err)
        })
      }
      else if (this.props.product === 'CC-Server') {
        api.registerCCServer(this.state.email, this.state.password, 
          this.state.name, search.get('socket-id'))
        .then(res => {
          const { data } = res
          if (data.error) return this.setState({ error: data.error })
          this.props.onSuccess();
        }).catch(err => {
          console.error(err)
          this.errorMessage(err)
        })
      }
    }
  }

  componentDidMount = () => {
    const search = new URLSearchParams(window.location.search);
    const cmsId = search.get('cms-id');
    const ccId = search.get('cc-server-id');
    if(cmsId){
      api.getCms(cmsId)
      .then((res) => {
        const { data } = res;
        if (data.error) return this.setState({ error: data.error })
        this.setState({
          isLogin: true,
          name: data.name,
        })
      }).catch(err => {
        console.error(err)
        this.setState({ error: `${err.response.data}. Re-registering instead.` })
      })
    }
    if(ccId){
      api.getCCServer(ccId)
      .then((res) => {
        const { data } = res;
        if (data.error) return this.setState({ error: data.error })
        this.setState({
          isLogin: true,
          name: data.name,
        })
      }).catch(err => {
        console.error(err)
        this.setState({ error: `${err.response.data}. Re-registering instead.` })
      })
    }
  };

    render() {
        return(
            <div className='card'>
                <div className='form-outline mt-2 mb-2'>
                    <label className='form-label' htmlFor='form2Example1'>Email address</label>
                    <input onChange={this.handleChange} value={this.state.email} name='email' type='email' className='form-control rounded-1' />
                </div>

                <div className='form-outline mb-2'>
                    <label className='form-label' htmlFor='form2Example2'>Password</label>
                    <input type='password' onChange={this.handleChange}  value={this.state.password} name='password' className='form-control rounded-1' />
                </div>

                <div className='form-outline mb-4'>
                    <label className='form-label' htmlFor='form2Example3'>{this.props.product} Name</label>
                    <input disabled={this.state.isLogin} onChange={this.handleChange} value={this.state.name} onKeyDown={(e) => { this.handleKeyDown(e) }} name='name' className='form-control rounded-1' />
                </div>

                {this.state.error ? <p className='error'>ERROR: {this.state.error}</p> : null}
                <button type='button' className='btn btn-primary btn-block' onClick={this.handleLogIn}>Log In</button>
            </div>
        )
    }
}

export default SSOSignIn;